module.exports = __webpack_public_path__ + "static/wl_logo-6049ca14aff05caeaea21550c1472940.png";